import { render, staticRenderFns } from "./tipos.vue?vue&type=template&id=41fe6c04"
import script from "./tipos.vue?vue&type=script&lang=js"
export * from "./tipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports